import React from "react";
import { Outlet } from "react-router-dom";
import ParentSkeleton from "./ParentSkeleton";

const DefaultLayout = () => {
  return (
    <div className="userLayoutWrapper">
      {/* <ParentSkeleton> */}
        <Outlet />
      {/* </ParentSkeleton> */}
    </div>
  );
};

export default DefaultLayout;
